import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './emp-payroll.css';
import { FaUsers } from 'react-icons/fa6';
import { IoEye } from 'react-icons/io5';
import { Col, Form, Modal, Button } from 'react-bootstrap';
import PayrollLayout from '../../../Components/PayrollLayout.jsx';
import { FaRegEdit } from "react-icons/fa";
import { Link } from 'react-router-dom';
import { FaFileAlt } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
 
export default function EmpPayroll() {
  const [payrollData, setPayrollData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage] = useState(10);
  const [showModal, setShowModal] = useState(false);
  const [selectedEmp, setSelectedEmp] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
    const navigate = useNavigate();
  const [selectedMonth, setSelectedMonth] = useState(
    new Date().toISOString().slice(0, 7)
  );
 
  useEffect(() => {
    const fetchPayrolls = async () => {
      try {
        setLoading(true);
        const res = await axios.get('https://backend.ems.hiradentallab.com/api/payroll/payroll');
       
        if (res.data && res.data.data) {
          setPayrollData(res.data.data);
          setFilteredData(res.data.data);
        } else {
          setError('No data returned from API');
        }
      } catch (error) {
        console.error('Error fetching payrolls:', error);
        setError('Failed to fetch payroll data');
      } finally {
        setLoading(false);
      }
    };
    fetchPayrolls();
  }, []);
 
  useEffect(() => {
    const results = payrollData.filter((emp) => {
      const nameMatch = emp.name?.toLowerCase().includes(searchTerm.toLowerCase()) || false;
     
      let monthMatch = true;
      if (selectedMonth) {
        try {
          const payrollDate = new Date(emp.startDate || emp.endDate);
          const payrollMonth = payrollDate.toISOString().slice(0, 7);
          monthMatch = payrollMonth === selectedMonth;
        } catch {
          monthMatch = false;}}  
      return nameMatch && monthMatch;
    });
    setFilteredData(results);
    setCurrentPage(1);
  }, [searchTerm, selectedMonth, payrollData]);
  const handleViewClick = (emp) => {
    setSelectedEmp(emp);
    setShowModal(true);
  };
  const handleClose = () => setShowModal(false);
  const handleMonthChange = (e) => {
    setSelectedMonth(e.target.value);
  };
  const handlePayinClick = (payrollId) => {
    navigate(`/pay-invoice/${payrollId}`);
  };
  const paginatedData = filteredData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );
  const totalPages = Math.ceil(filteredData.length / rowsPerPage);
  const getSafeValue = (obj, path, defaultValue = 'N/A') => {
    try {
      const value = path.split('.').reduce((o, p) => o?.[p], obj);
      return value !== undefined ? value : defaultValue;
    } catch {
      return defaultValue;
    }
  };
  const formatDate = (dateString) => {
    try {
      return dateString ? new Date(dateString).toLocaleDateString() : 'N/A';
    } catch {
      return 'N/A';
    }
  };
  if (loading) {
    return (
      <PayrollLayout>
        <div className="text-center mt-5">Loading payroll data...</div>
      </PayrollLayout>
    );
  }
  if (error) {
    return (
      <PayrollLayout>
        <div className="text-center mt-5 text-danger">{error}</div>
      </PayrollLayout>
    );
  }
  return (
    <PayrollLayout>
      <h1 className="emps-payroll-title">
        <FaUsers /> Employees Payroll
      </h1>
      <hr />
      <div className="emps-payroll-content">
        <div className="filter-container">
          <Col xs={12} md={4} className="d-flex align-items-center">
            <input
              type="month"
              className="form-control"
              value={selectedMonth}
              onChange={handleMonthChange}
            />
          </Col>
          <Col xs={12} md={8} className="filter-right">
            <Form className="d-flex">
              <Form.Control
                type="search"
                placeholder="Search by name..."
                className="depts-search-bar"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </Form>
          </Col>
        </div>
        {/* Table */}
        <div className="table-responsive">
          {filteredData.length > 0 ? (
            <table className="table table-striped">
              <thead className="table-header">
                <tr className="emps-payroll-table-header">
                  <th>SR</th>
                  <th>UserId</th>
                  <th>Name</th>
                  <th>Basic Salary</th>
                  <th>Total Working Days</th>
                  <th>Total Days Worked</th>
                  <th>Absent</th>
                  <th>Over-time</th>
                  <th>Working Units</th>
                  <th>Unit Pay rate</th>
                  <th>public Holiday Pay</th>
                  <th>Final Salary</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {paginatedData.map((emp, index) => (
                  <tr key={emp._id || index}>
                    <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>        
                    <td>{getSafeValue(emp, 'userId')}</td>
                    <td>{getSafeValue(emp, 'name')}</td>
                    <td>{getSafeValue(emp, 'basicSalary', 0)}</td>
                    <td>{getSafeValue(emp, 'totalWorkingDays', 0)}</td>
                    <td>{getSafeValue(emp, 'totalDaysWorked', 0)}</td>
                    <td>{getSafeValue(emp, 'totalMinutesDeduction', 0)}</td>
                    <td>{getSafeValue(emp, 'extraMinutesBonus', 0)}</td>
                    <td>{getSafeValue(emp, 'workingUnits', 0)}</td>
                    <td>{getSafeValue(emp, 'unitPayRate', 0)}</td>
                    <td>{getSafeValue(emp, 'publicHolidayPay', 0)}</td>
                    <td>{getSafeValue(emp, 'finalSalary', 0)}</td>
                    <td>{formatDate(emp.startDate)}</td>
                    <td>{formatDate(emp.endDate)}</td>
                    <td>
                      <div className="d-flex gap-2">
                        <Button variant='primary' size='sm' onClick={() => handleViewClick(emp)}>
                          <IoEye />
                        </Button>
                        <Link to={`/edit-payroll/${getSafeValue(emp, '_id')}`}>
                          <Button variant='warning' size='sm'>
                            <FaRegEdit />
                          </Button>
                        </Link>
                        <Button
                              variant="success"
                              size='sm'
                              onClick={() => handlePayinClick(emp._id)}
                            >
                              <FaFileAlt />
                            </Button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot className='table-footer'>
                <tr className='emps-payroll-table-footer'>
                  <td>Total:</td>
                  <td>{paginatedData.length}</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tfoot>
            </table>
          ) : (
            <p>No payroll data available for the selected month</p>
          )}
        </div>
        {/* Pagination */}
        <div className="pagination-buttons">
          {totalPages > 1 &&
            Array.from({ length: totalPages }, (_, i) => (
              <Button
                key={i}
                onClick={() => setCurrentPage(i + 1)}
                className={currentPage === i + 1 ? 'btn btn-dark' : 'btn btn-light'}
              >
                {i + 1}
              </Button>
            ))}
        </div>
        {/* Modal */}
        <Modal show={showModal} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Payroll Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedEmp && (
              <div>
                <p><strong>Name:</strong> {getSafeValue(selectedEmp, 'name')}</p>
                <p><strong>Basic Salary:</strong> {getSafeValue(selectedEmp, 'basicSalary')}</p>
                <p><strong>Total Working Days:</strong> {getSafeValue(selectedEmp, 'totalWorkingDays')}</p>
                <p><strong>Total Days Worked:</strong> {getSafeValue(selectedEmp, 'totalDaysWorked')}</p>
                <p><strong>Absent Deduction:</strong> {getSafeValue(selectedEmp, 'totalMinutesDeduction')}</p>
                <p><strong>Overtime:</strong> {getSafeValue(selectedEmp, 'extraMinutesBonus')}</p>
                <p><strong>Working Units:</strong> {getSafeValue(selectedEmp, 'workingUnits')}</p>
                <p><strong>Unit Pay Rate:</strong> {getSafeValue(selectedEmp, 'unitPayRate')}</p>
                <p><strong>Final Salary:</strong> {getSafeValue(selectedEmp, 'finalSalary')}</p>
                <p><strong>Start Date:</strong> {formatDate(selectedEmp.startDate)}</p>
                <p><strong>End Date:</strong> {formatDate(selectedEmp.endDate)}</p>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </PayrollLayout>
  );
} 